import { VOID_REASON_LABELS, VOID_REASON_UNKNOWN_LABEL, isVoidReason } from '@barso/shared';
import type { LocalSale } from './types';

/**
 * Klartext „Grund: Doppelt erfasst“ für einen stornierten Verkauf (U17d), `null`, wenn nichts storniert ist. Teilstornos
 * tragen je Zeile ihren Grund: Verschiedene Gründe stehen nacheinander, gleiche nur einmal. Der Freitext folgt nach einem
 * Doppelpunkt. Verkäufe ohne Grund (ältere Kasse, Korrektur vor U17d) zeigen „ohne Angabe“.
 */
export function voidReasonLine(sale: Pick<LocalSale, 'lines'>): string | null {
  const parts: string[] = [];
  for (const line of sale.lines) {
    if (!line.voided) continue;
    const label = isVoidReason(line.voidReason)
      ? VOID_REASON_LABELS[line.voidReason]
      : VOID_REASON_UNKNOWN_LABEL;
    const note = line.voidNote?.trim() ?? '';
    const text = note === '' ? label : `${label}: ${note}`;
    if (!parts.includes(text)) parts.push(text);
  }
  return parts.length === 0 ? null : `Grund: ${parts.join('; ')}`;
}
